module.exports = "<div class=\"footer\">\r\n  <div class=\"text-center\">\r\n    2015-{{nowYear}} 泰乐医生 版权所有\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-footing/index-footing.component.html
// module id = ../../../../../ng-src/app/module/index-operation/index/index-footing/index-footing.component.html
// module chunks = main